// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","shortTextField":"CustomExtendedDataField_shortTextField__mTYGg CustomExtendedDataField_customField__qwZyL"};